import React from 'react';

import svg from './assets/icons-36-pinterest.svg';
import type { IconProps } from './SvgIcon';
import { SvgIcon } from './SvgIcon';

export const IconPinterest = (props: IconProps) => (
  <SvgIcon {...props} src={svg} testId="icon-pinterest" />
);
